import { View } from '@shared/components/View';
import { MBLoadingIndicator } from '@shared/components/loading';
import { useBoolean } from '@shared/util/hooks';
import { MBVideoProps } from './props';

export function MBVideo({ fill, source, muted, ...otherProps }: MBVideoProps) {
  const [loading, startLoading, stopLoading] = useBoolean(true);

  return (
    <View fill={fill}>
      {loading && <MBLoadingIndicator absolute />}
      <video
        controls
        playsInline
        muted={muted}
        style={{ width: '100%', height: '100%' }}
        onLoadStart={startLoading}
        onLoadedMetadata={stopLoading}
        {...otherProps}
      >
        <source src={source.uri} />
      </video>
    </View>
  );
}
